import { SSOProvider, EMAIL_LOGIN_PROVIDER } from 'src/types';
import log from 'src/utils/logger';

const STORAGE_KEY = 'ninja_last_login';

export interface LastLoginInfo {
  email: string;
  loginType: typeof EMAIL_LOGIN_PROVIDER | SSOProvider;
  timestamp: number;
}

/**
 * Save last login information to localStorage
 * This storage persists across logout (separate from Redux persist)
 */
export function saveLastLogin(
  email: string,
  loginType: typeof EMAIL_LOGIN_PROVIDER | SSOProvider,
): void {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    const data: LastLoginInfo = {
      email,
      loginType,
      timestamp: Date.now(),
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch (error) {
    log.error('Failed to save last login info:', error);
  }
}

/**
 * Get last login information from localStorage
 * Returns null if no data exists or data is invalid
 */
export function getLastLogin(): LastLoginInfo | null {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) {
      return null;
    }

    const data = JSON.parse(stored) as LastLoginInfo;

    // Validate data structure
    if (!data.email || !data.loginType || !data.timestamp) {
      return null;
    }

    return data;
  } catch (error) {
    log.error('Failed to get last login info:', error);
    return null;
  }
}

/**
 * Clear last login information
 */
export function clearLastLogin(): void {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    log.error('Failed to clear last login info:', error);
  }
}
